/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, lazy } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Styled from './style';
import Button from '@material-ui/core/Button';
import Message from 'globalcomponents/UI/Message/Clutch';
import { hasValue } from 'globalutils/fmUtils';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import green from '@material-ui/core/colors/green';
import {
  pageUrls,
  COOKIE_AUTH_DETAILS
} from 'globalconfig/constants/keys';
import { getCookie, setCookie } from 'globalservices/cookie';
import underscore from 'underscore';

const layout = window.$environment?.CURRENT_LAYOUT;
const Input = lazy(() =>
  import(`globalcomponents/UI/Input/${layout}`)
);

const AdditionalDetails = ({ history, truckInfo }) => {
  const apiStatus = useSelector((state) => state.asyncRequests);
  const dispatch = useDispatch();
  const apiId = 'isValidVIN';
  const hasValidVinApiStatus = hasValue(apiStatus?.status, 'api', apiId);

  const [data, setData] = useState(
    truckInfo.onboardingTrucks
      ? truckInfo.onboardingTrucks.map((item) => {
          item.isValid = false;
          item.hasError = '';
          return item;
        })
      : []
  );

  // const [isValid, setIsValidAll] = useState(false);
  const [idx, currentIdx] = useState(0);
  const handleEdit = (event, index, companyId, vehicleId) => {
    setData(
      data.map((key, i) => {
        if (i === index)
          return { ...key, vin: event, isValid: false, hasError: '' };
        return key;
      })
    );
    // setIsValidAll(false);
    const found = data.some((el) => {
      return el.vehicleId !== vehicleId && el.vin === event;
    });

    if (found) {
      setData(
        data.map((key, i) => {
          if (i === index) return { ...key, vin: event, isValid: true };
          return key;
        })
      );
    } else if (!found && event.length === 17) {
      currentIdx(index);
      dispatch.vehicleAdd.isValidVinForClutch({
        apiId: 'isValidVIN',
        data: {
          vin: event,
          companyId: companyId
        }
      });
    }
  };
  
  const goToDashboard = () => {
    let present = document.querySelector("[type = 'error']");
    if (!present) {
      var newArr = underscore.map(data, function (o) {
        return underscore.omit(o, ['isValid', 'hasError']);
      });

      dispatch.truckInfo.updateAllTruckData({
        data: newArr,
        id: 'updateTrucks'
      });
    }
  };

  const updateValue = (val) => {
    return val.substring(0, 17);
  };

  const showError = (field, apiError, index) => {
    if (apiError?.[field]) {
      setData(
        data.map((key, i) => {
          if (i === index) return { ...key, hasError: apiError[field] };
          return key;
        })
      );
    }
  };

  useEffect(() => {
    showError(
      `vin`,
      hasValue(apiStatus?.status, 'api', `isValidVIN`)?.errorMessage,
      idx
    );
  }, [apiStatus?.status]);

  useEffect(() => {
    if (truckInfo.updateSuccess === 'Success') {
      tokenVal.onboardCompleted = true;
      const token = getCookie(COOKIE_AUTH_DETAILS);
      setCookie(COOKIE_AUTH_DETAILS, tokenVal, token.rememberMe);
      history.push(pageUrls.dashboard);
    }
  }, [truckInfo.updateSuccess]);

  const [tokenVal, setTokenVal] = useState({});

  useEffect(() => {
    const token = getCookie(COOKIE_AUTH_DETAILS);
    setTokenVal(token);
  }, []);

  return (
    <Styled.Wrapper>
      <div className="welcomeText">
        <h1 className="stepTitle">Additional Details</h1>
        <div className="details">
          {data.map((key, index) => {
            return (
              <div className="truckInfoitems">
                <div className="headerSection">
                  <h2>Truck Information</h2>
                  <span className="index">
                    <span className="indexNo">{index + 1}</span>
                    <span className="nextHalf">
                      <span>/</span>
                      {data.length}
                    </span>
                  </span>
                </div>
                <div className="infoWrapper infoFirst">
                  {[
                    { label: 'Vehicle Type', value: key.type },
                    { label: 'Unit ID', value: key.unitId }
                  ].map(({ label, value }) => (
                    <div className="listItems" key={label}>
                      <span className="listLabel">{label}</span>
                      <span className="itemValue">{value}</span>
                    </div>
                  ))}
                </div>

                <div className="infoWrapper">
                  {[
                    { label: 'Year', value: key.year },
                    { label: 'Make', value: key.make },
                    { label: 'Model', value: key.model }
                  ].map(({ label, value }) => (
                    <div className="listItems" key={label}>
                      <span className="listLabel">{label}</span>
                      <span className="itemValue">{value}</span>
                    </div>
                  ))}
                </div>

                <div className="infoWrapper">
                  <div className="listItems vinWrapper">
                    <span className="listLabel">VIN#</span>
                    <Input
                      handleOnChange={(event) => {
                        handleEdit(event, index, key.companyId, key.vehicleId);
                      }}
                      value={key.vin ? key.vin : ''}
                      placeholder="Type VIN Number"
                      updateValue={(e) => updateValue(e)}
                      name={`vin`}
                    />

                    <div className="apiProgress">
                      {index === idx &&
                        hasValidVinApiStatus?.isValidVinLoading && (
                          <CircularProgress style={{ color: green[500] }} />
                        )}
                    </div>

                    {[
                      key.isValid &&
                        `Vehicle with vin ${key.vin} already exists`,
                      key.hasError && key.hasError,
                      key.vin?.length > 0 &&
                        key.vin?.length < 17 &&
                        'VIN number must be 17 characters long. Numbers and letters only. I, O, or Q are not allowed',
                      !key.vin && 'This field is required'
                    ]
                      .filter(Boolean)
                      .map((message, i) => (
                        <Message key={i} type="error" message={message} />
                      ))}

                    <div className="validVinIcon">
                      {!key.isValid &&
                      key.vin?.length === 17 &&
                      !hasValidVinApiStatus?.isValidVinLoading &&
                      key.hasError === '' ? (
                        <CheckCircleOutlinedIcon
                          style={{ color: green[500] }}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="gotoWrapper">
          <Button
            variant="contained"
            id="goToDashboard"
            onClick={() => {
              goToDashboard();
            }}
          >
            Go To Dashboard
          </Button>
        </div>
      </div>
    </Styled.Wrapper>
  );
};

export default AdditionalDetails;

AdditionalDetails.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired
};
